<template>
  <ul class="node_list_ul">
    <li class="list_li" v-for="(item, index) in arr" :key="index">
      <div
        :class="[
          'li_big',
          {
            active:
              (gxbText && item.code === '101610') ||
              (sifaText && item.code === '101614'),
          },
        ]"
        @click="hrefJump(item)"
      >
        {{
          gxbText && item.code === "101610"
            ? gxbText
            : sifaText && item.code === "101614"
            ? sifaText
            : item.name
        }}
      </div>
      <!-- 工信部用 -->
      <div
        :class="['li_small', { copy_class: item.code === '101610' }]"
        :data-clipboard-text="gxbText"
        v-show="gxbText && item.code === '101610'"
        @click="copyHref(item.linkPc)"
      >
        复制并前往
      </div>
      <!-- 司法生态链用 -->
      <div
        :class="['li_small', { copy_class: item.code === '101614' }]"
        :data-clipboard-text="sifaText"
        v-show="sifaText && item.code === '101614'"
        @click="copyHref(item.linkPc)"
      >
        复制并前往
      </div>
    </li>
  </ul>
</template>

<script>
import BlockChain from "../../assets/js/http-serve/blockChain";
import { ApiMethods } from "../../assets/js/http-serve/http-methods";
import Clipboard from "clipboard";
import { isInDingTalk } from '@/assets/js/utils/ding-env';
// 改为动态引入
let dd = null
if (process.client) {
  dd = require('dingtalk-jsapi')
}

export default {
  name: "node-query",
  props: {
    vpresId: String
  },
  data () {
    return {
      arr: [],
      gxbText: "",
      sifaText: ""
    };
  },
  mounted () {
    this.getChinaList();
  },
  methods: {
    //  获取节点
    getChinaList () {
      BlockChain.getChainNodeList("").then(res => {
        let chainArr = res.data;
        this.arr = res.data.filter(item => {
          return !['101614', '101610'].includes(item.code)
        });
        let onlineSearchArr = chainArr.slice(0, 9); // 是否支持在线查询
        let notOnlineSearchArr = chainArr.slice(9); //（不支持的显示在更多内
        // this.chainList = this.showMore
        //   ? onlineSearchArr.concat(notOnlineSearchArr)
        //   : onlineSearchArr;
        // this.supportList = onlineSearchArr;
        // this.notSupportList = notOnlineSearchArr;
      });
    },
    //  dian点击节点
    hrefJump (item) {
      if (item.code === "101610") {
        ApiMethods.ApplySignController.nodeHumiQuery({
          presId: this.vpresId
        }).then(res => {
          if (res.data) {
            this.gxbText =
              res.success && res.data ? res.data : "工信部标识生成中";
          } else {
            this.$message.warning("暂未获取到工信部标识");
          }
        });
      } else if (item.code === "101614") {
        ApiMethods.ApplySignController.sifaNodeQuery({
          presId: this.vpresId
        }).then(res => {
          if (res.data) {
            this.sifaText =
              res.success && res.data ? res.data : "工信部标识生成中";
          } else {
            this.$message.warning("暂未获取到司法生态链编号");
          }
        });
      } else {
        isInDingTalk ? this.dingOpen(item.linkPc) : window.open(item.linkPc);
      }
    },
    dingOpen (app_url) {
      dd.biz.util.invokeWorkbench({ app_url })
    },
    //  复制
    copyHref (href) {
      const clipboard = new Clipboard(".copy_class");
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
        setTimeout(() => {
          isInDingTalk ? this.dingOpen(href) : window.open(href);
        }, 500);
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    }
  }
};
</script>

<style scoped lang="less">
.node_list_ul {
  padding: 35px 50px;
  display: flex;
  justify-content: flex-start;
  background-color: #f0f2f8;
  flex-wrap: wrap;
  .list_li {
    width: 30%;
    margin-bottom: 20px;
    text-align: center;
    &:nth-child(3n-1) {
      margin: 0 5%;
    }
    .li_big {
      margin-bottom: 10px;
      text-align: center;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: #ffffff;
      color: #000000;
      box-shadow: 0 0 10px 2px rgba(244, 245, 249, 0.9);
      cursor: pointer;
      &.active {
        background-color: #d93a30;
        color: #ffffff;
        font-size: 12px;
      }
    }
    .li_small {
      background-color: #d93a30;
      color: #ffffff;
      padding: 4px 10px;
      border-radius: 4px;
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/signInfo/node-query.vue